import { useSelector, useDispatch } from "react-redux";
import CONSTANTS from "../../Constants";
import { isMobile, priceFormat } from "../../helpers/helpers";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { setSelectedOperationsToStore, setSelectedForfaitsToStore, setSelectedMandatoryAdditionalForfaitsToStore, setSelectedPremiumServicesToStore, setSelectedMileageStep } from "../../redux-files/actions/action";
import './Quote.scss'
import { pushEventToGTM } from "../../helpers/trackerManager";

const Quote = ({ children, title, isSummaryPage = false }) => {

    const selectedForfaitFromStore = useSelector(state => state.ndel_store.selectedForfaits)
    const selectedMandatoryAdditionalForfFromStore = useSelector(state => state.ndel_store.selectedMandatoryAdditionalForfaits)
    const storeSelectedOperations = useSelector(state => state.ndel_store.selectedOperations)
    const appointmentInfo = useSelector(state => state.ndel_store.appointment)
    const [totalPrice, setTotalPrice] = useState(0)
    const dispatch = useDispatch()
    // const isCurrencyBeforePrice = !!Number(window.siteConfig.PoundPlacement);
    useEffect(() => {
        console.log('Your quote useEffect run ...')
        let totPrice = 0
        selectedForfaitFromStore.map(forfait => {
            totPrice += forfait.Items[0].Prix
            if (forfait.forfaitFamilyCode === 'FCT0002') {
                selectedMandatoryAdditionalForfFromStore.map(mandOp => {
                    totPrice += mandOp.Items[0].Prix
                })
            }
        })
        setTotalPrice(totPrice)
    }, []);

    const removeOperation = (oper, isPremiumService = false) => {
        if (!isPremiumService) {
            let priceTot = totalPrice
            selectedForfaitFromStore.map(forfait => {

                if (oper.interventionForfaits.some(intervForf => intervForf.Code === forfait.forfaitFamilyCode)) {
                    priceTot -= forfait.Items[0].Prix
                }
                if (oper.codeFamilyForfait === 'FCT0002') {
                    selectedMandatoryAdditionalForfFromStore.map(mandOp => {
                        priceTot -= mandOp.Items[0].Prix
                    })
                }
            })
            setTotalPrice(priceTot)
            dispatch(setSelectedOperationsToStore(storeSelectedOperations.filter(item => item.interventionId !== oper.interventionId)))
            dispatch(setSelectedForfaitsToStore(selectedForfaitFromStore.filter(forfait => !(oper.interventionForfaits.some(intervForf => intervForf.Code === forfait.forfaitFamilyCode)))));
            if (oper.codeFamilyForfait === 'FCT0002') {
                dispatch(setSelectedMandatoryAdditionalForfaitsToStore([]))
                dispatch(setSelectedMileageStep({}))
            }
        }

    }

    const removeMandatoryForfait = (forfait, mandatroyOperation) => {

        setTotalPrice(totalPrice - mandatroyOperation.Items[0].Prix)

        let forfaitformStoreNoOpertations = selectedForfaitFromStore.filter(storeForf => storeForf.Items[0].Ref !== forfait.Items[0].Ref)
        let forfaitformStoreWithOpertations = selectedForfaitFromStore.filter(storeForf => storeForf.Items[0].Ref === forfait.Items[0].Ref)
        forfaitformStoreWithOpertations[0].Operations && forfaitformStoreWithOpertations[0].Operations.map(mandOper => {

            if (mandOper.Items[0].Ref === mandatroyOperation.Items[0].Ref) {
                mandOper.isSelected = false

            }
        })
        dispatch(setSelectedForfaitsToStore(forfaitformStoreNoOpertations.concat(forfaitformStoreWithOpertations)))
        dispatch(setSelectedMandatoryAdditionalForfaitsToStore(selectedMandatoryAdditionalForfFromStore.filter(mandatoryOper =>
            mandatoryOper.Items[0].Ref !== mandatroyOperation.Items[0].Ref
        )))
    }
    const totalPriceDiscount = isSummaryPage ? totalPrice - totalPrice * appointmentInfo.happyHour * 0.01 : totalPrice
    return (
        <div className='quote-content-container'>
            {!isMobile() && <div className='row'>
                <div tabIndex="0" className='content-title'>{title}</div>

                <Link
                    to={CONSTANTS.SITE_ROUTS.OPERATIONSPAGE}
                    onClick={() => isSummaryPage ? pushEventToGTM({
                        pageName: 'summary',
                        eventAction: 'Redirection::Internal::Services',
                        eventLabel: CONSTANTS.LABELS.quote_add_operation,
                        eventCategory: 'Content'
                    }) : pushEventToGTM({
                        pageName: 'quoting',
                        eventAction: 'Redirection::Internal::Services',
                        eventLabel: CONSTANTS.LABELS.quote_add_operation,
                        eventCategory: 'Content'
                    })}
                    className='icons plus-icon addOperation-link'>
                    {CONSTANTS.LABELS.quote_add_operation}
                </Link>
            </div>}
            {isMobile() && <div className='row'>
                <div className='headline'>{CONSTANTS.LABELS.header_quote_ariane2}</div>
                {isSummaryPage && <Link
                    to={CONSTANTS.SITE_ROUTS.OPERATIONSPAGE}
                    className='icons plus-icon addOperation-link'>
                    {CONSTANTS.LABELS.quote_add_operation}
                </Link>}
            </div>}
            {isSummaryPage && !!appointmentInfo.happyHour && <p className='happyHpour' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.email_happy_hour.replace('{{>Basket.Reduction}}', appointmentInfo.happyHour)) }}></p>}
            {storeSelectedOperations.map(oper => {
                return (
                    <div key={oper.interventionId}>
                        <div className='op-block'>
                            {!isSummaryPage && !isMobile() && <i className='op-icon' style={{ backgroundImage: `url(${oper.Image})` }} ></i>}
                            <div tabIndex="0" className="op-title">
                                {oper.interventionLabel}
                            </div>
                            <i tabIndex='0' role="button" className={`trash-icon`} onClick={() => removeOperation(oper)} onKeyDown = {(e)=> e.key === 'Enter' && removeOperation(oper)}/>
                        </div>
                        <div className='forfaits-container'>
                            {selectedForfaitFromStore.map((forfait, index) => {
                                const Price = isSummaryPage ? forfait.Items[0].Prix - (forfait.Items[0].Prix * appointmentInfo.happyHour * 0.01) : forfait.Items[0].Prix
                                return (
                                    (oper.interventionForfaits.some(intervForf => intervForf.Code === forfait.forfaitFamilyCode)) &&
                                    <div key={index} className='forfait-block'>
                                        <div tabIndex="0" className='forfait-info'>
                                            <div className='forfait-name'>{forfait.Libelle}</div>
                                            <div className='forfait-price'>
                                                {priceFormat(Price)} <span className='label-tax'>{CONSTANTS.LABELS.needs_basket_label2}</span>
                                            </div>
                                        </div>

                                        {oper.codeFamilyForfait === 'FCT0002' && <div className='Mandatory-operations-container'>
                                            {selectedMandatoryAdditionalForfFromStore.map((mandatroyOperation, MandOPerIndex) => {
                                                const mandatoryPrice = isSummaryPage ? mandatroyOperation.Items[0].Prix - (mandatroyOperation.Items[0].Prix * appointmentInfo.happyHour * 0.01) : mandatroyOperation.Items[0].Prix
                                                return (
                                                    <div key={MandOPerIndex} className='mandatory-operation-info'>
                                                        <div className='first-row'>
                                                            <div className='mandatory-opertation-name'>{mandatroyOperation.Libelle}</div>
                                                            {!isMobile() && <div className='mandatory-opertation-price'>
                                                                {priceFormat(mandatoryPrice)} <span className='label-tax'>{CONSTANTS.LABELS.needs_basket_label2}</span>
                                                            </div>}
                                                            <i tabIndex='0' role="button" className='trash-icon' onClick={() => removeMandatoryForfait(forfait, mandatroyOperation)} onKeyDown = {(e)=> e.key === 'Enter' && removeMandatoryForfait(forfait, mandatroyOperation)} />
                                                        </div>
                                                        {isMobile() && <div className='mandatory-opertation-price'>
                                                            {priceFormat(mandatoryPrice)} <span className='label-tax'>{CONSTANTS.LABELS.needs_basket_label2}</span>
                                                        </div>}
                                                    </div>
                                                );
                                            })}
                                        </div>}
                                    </div>
                                );
                            })}
                        </div>

                    </div>
                );
            })
            }
            {children}
            {// show in summary page (mbile and Desktop) and mobile Quote Page
                (isSummaryPage || (!isSummaryPage && !isMobile())) && <div tabIndex="0" className='totalPrice-block'>
                    <div className='label'>{CONSTANTS.LABELS.needs_basket_maintenance_label9}</div>
                    <div className='prix'>
                        {priceFormat(totalPriceDiscount)} {<span className='tax-incl'>{CONSTANTS.LABELS.needs_basket_label2}</span>}
                    </div>
                </div>
            }
        </div>
    );
}

export default Quote;